import type { FileKind, MediaPart, PageSize, SheetTier } from './library';

/** One downloadable part of a file as listed in the manifest (etag unquoted, as stored in R2). */
export interface ManifestPartInfo {
  size: number;
  etag: string;
  /** Content-Type the media route serves for this part. */
  mime: string;
}

/** GET /api/offline/manifest — everything this user may cache. Authoritative for pruning. */
export interface ManifestFile {
  id: string;
  songId: string;
  kind: FileKind;
  rev: number;
  audienceMask: number;
  title: string;
  parts: Partial<Record<MediaPart, ManifestPartInfo>>;
  pages: PageSize[] | null;
  lyricsText: string | null;
}

export interface ManifestDTO {
  generatedAt: number;
  userId: string;
  files: ManifestFile[];
  /** song → visible file ids (so a pack for a song/setlist can be resolved offline) */
  songs: Record<string, string[]>;
  collections: Record<string, string[]>; // collection → song ids (ordered)
}

export function mediaUrl(fileId: string, rev: number, part: MediaPart): string {
  return `/api/media/${fileId}/${rev}/${part}`;
}

export function avatarUrl(userId: string, rev: number, size: 128 | 512): string {
  return `/api/avatar/${userId}/${rev}/${size}`;
}

export type { SheetTier };
